import React from 'react'
import { Link } from 'react-router-dom';
import HomeServiceData from '../../../utils/data/home/HomeServiceData.json';

export default function HomeServices() {
    return (
        <div className="container  progress-container mt-3 mb-5">
            <div className="row row-cols-1 row-cols-lg-4 row-cols-md-2 row-cols-xs-1 g-2 g-lg-3 " >
                <div className="col" >
                    <div className='home_row_line' ></div>
                    <h3 className="home-services-main-title">Our Services</h3>
                    <div className="row row-cols-1 row-cols-lg-4 row-cols-md-2 row-cols-xs-1 g-2 g-lg-3 justify-content-center" >
                    </div>
                </div>
            </div>

            <div className="row row-cols-1 row-cols-lg-4 row-cols-md-2 row-cols-xs-1 g-2 g-lg-3 mt-2">
                {
                    HomeServiceData.map((data, key) => (
                        <div key={key} className="col-xl-3 col-lg-4 home_service_card_col" >
                            <div className="card card-image">
                                <img src={data.image} className="card-img-top homeservice-image" alt="Loading.." />
                                <div className="card-body">
                                    <h5 className="card-title homeservice-title"> {data.title} </h5>
                                    <p className="card-text homeservice-text"> {data.text} </p>
                                    <Link to="/services" className="btn btn-primary homeservice-link "> {data.buttonText} </Link>
                                </div>
                            </div>
                        </div>
                    ))
                }

            </div>
        </div>
    )
}
